import { DateWorkerInput } from '@core/utils/date-worker/models';
import { RangePickerValues } from '@models/interfaces';
import { RangePickerProps } from '../interfaces';
import { reverseType } from './reverse-type';

export const changeValue =
  (
    type: keyof RangePickerValues,
    onChange: RangePickerProps['onChange'],
    value: RangePickerProps['value'],
  ) =>
  (changedValue: DateWorkerInput): void => {
    const oppositeType = reverseType(type);

    onChange?.(
      !changedValue && !value?.[oppositeType]
        ? undefined
        : { ...value, [type]: changedValue },
    );
  };
